export interface ApiResponseIssuanceError {
  code: string;
  message: string;
}

export interface ApiResponseInvoice {
  invoiceUploadDate: string | null;
  invoiceUuid: string | null;
  updatedAt: string;
  issuanceErrors: ApiResponseIssuanceError[] | null;
}

export enum IssuanceErrorCode {
  UNKNOWN_INVOICE_ERROR = 'UNKNOWN_INVOICE_ERROR',
  UNKNOWN_INVOICE_CALLBACK_ERROR = 'UNKNOWN_INVOICE_CALLBACK_ERROR',
  INVALID_PDF_ATTACHMENT = 'INVALID_PDF_ATTACHMENT',
  OTHER = 'OTHER',
}

export interface IssuanceError {
  code: IssuanceErrorCode;
  message: string;
}

export interface Invoice {
  uuid: string | null;
  uploadDate: Date | null;
  updatedAt: Date;
  issuanceErrors: IssuanceError[];
}

export function fromApiInvoice(api: ApiResponseInvoice): Invoice {
  return {
    uuid: api.invoiceUuid,
    uploadDate: api.invoiceUploadDate ? new Date(api.invoiceUploadDate) : null,
    updatedAt: new Date(api.updatedAt),
    issuanceErrors: (api.issuanceErrors ?? []).map((error) => ({
      message: error.message,
      code: parseErrorCode(error.code),
    })),
  };
}

const parseErrorCode = (code: string): IssuanceErrorCode => {
  switch (code) {
    case IssuanceErrorCode.UNKNOWN_INVOICE_ERROR:
    case IssuanceErrorCode.UNKNOWN_INVOICE_CALLBACK_ERROR:
    case IssuanceErrorCode.INVALID_PDF_ATTACHMENT:
      return code as IssuanceErrorCode;
    default:
      return IssuanceErrorCode.OTHER;
  }
};

export const getPrimaryErrorCode = (
  issuanceErrors: IssuanceError[],
): IssuanceError | undefined => {
  if (!issuanceErrors || issuanceErrors.length === 0) {
    return undefined;
  }

  return (
    issuanceErrors.find(
      (error) =>
        error.code === IssuanceErrorCode.UNKNOWN_INVOICE_ERROR ||
        error.code === IssuanceErrorCode.UNKNOWN_INVOICE_CALLBACK_ERROR,
    ) ||
    issuanceErrors.find(
      (error) => error.code === IssuanceErrorCode.INVALID_PDF_ATTACHMENT,
    ) ||
    issuanceErrors.find((error) => error.code === IssuanceErrorCode.OTHER)
  );
};
